import React, { useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { FaCaretDown } from 'react-icons/fa';
import QrReader from 'react-qr-reader';
import Swal from 'sweetalert2';
import { COLOR } from '../../const/color';
import { getAllWarehouseLocations } from '../../const/HubConfig';
import { supportsWebcam } from '../../utils/supportsWebcam';
import { PenIcon } from './penIcon';
import './QrCameraScanner.scss';
import './QrWarehouseScanner.scss';
import { SvgBackground } from './tapScreen';

export function QrWarehouseScanner({
  addScannedOrder,
  updateScannedOrder,
  deleteScannedOrder,
  ordersOrderidList,
  warehouseLocation,
  setWarehouseLocation,
  disabledButton = false,
  titleButton = 'CONFIRM',
  scannerIsOpen,
  addOrDelete,
  setScannerIsOpen,
}: {
  addScannedOrder?;
  updateScannedOrder?;
  deleteScannedOrder?;
  ordersOrderidList?;
  warehouseLocation?: string;
  setWarehouseLocation?: (selectedWarehouse) => void;
  disabledButton?: boolean;
  titleButton: string;
  scannerIsOpen;
  addOrDelete?;
  setScannerIsOpen?: (isOpen: boolean) => void;
}): JSX.Element {
  const scanDelay = 300;
  console.log('warehouseLocation: ', warehouseLocation);
  const [theScannerIsOpen, setTheScannerIsOpen] = useState(scannerIsOpen);
  console.log('theScannerIsOpen', theScannerIsOpen);
  const [scanResultOrderId, setScanResultOrderId] = useState('');
  const [editResultOrderId, setEditResultOrderId] = useState('');
  const [displayOrderId, setDisplayOrderId] = useState('');
  const [parcelId, setParcelId] = useState('');

  const svgString = encodeURIComponent(renderToStaticMarkup(<SvgBackground />));
  const dataUri = `url("data:image/svg+xml,${svgString}")`;

  const svgStringPenIcon = (colorIcon = 'white') => {
    return encodeURIComponent(renderToStaticMarkup(PenIcon(colorIcon)));
  };

  const dataUriPenIcon = colorIcon => {
    return `url("data:image/svg+xml,${svgStringPenIcon(colorIcon)}")`;
  };

  const chooseWarehouseLocationModal = async () =>
    await Swal.fire({
      title: 'Select the warehouse location',
      input: 'select',
      inputOptions: getAllWarehouseLocations(),
      inputPlaceholder: 'Select a location',
      showCancelButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(resolve => setWarehouseLocation(resolve.value));

  const openScanner = () => {
    setScannerIsOpen(true);
    chooseWarehouseLocationModal();
  };

  const closeScanner = () => {
    setTheScannerIsOpen(false);
    setScanResultOrderId('');
  };

  const parseJsonData = data => {
    try {
      return JSON.parse(data);
    } catch (e) {
      return undefined;
    }
  };

  const EditInputField = ({ isDisabled = false }) => {
    return (
      <div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            borderRadius: '4px',
            border: `1px solid ${
              isDisabled ? COLOR.LIGHTER_GRAY : COLOR.GREEN
            }`,
            borderColor: isDisabled ? COLOR.LIGHTER_GRAY : COLOR.GREEN,
          }}
        >
          <input
            type={'tel'}
            onChange={onInputChange}
            value={displayOrderId}
            style={{
              width: '250px',
              fontSize: '3rem',
              textAlign: 'center',
              border: 'none',
            }}
            disabled={isDisabled}
            ref={input => input && input.focus()}
          />
          <button
            className="qr-penIcon-button"
            style={{
              background: `${dataUriPenIcon(
                isDisabled ? COLOR.LIGHTER_GRAY : COLOR.PRIMARY
              )}  no-repeat`,
              height: 25,
              width: 25,
              paddingLeft: 50,
            }}
            disabled={!theScannerIsOpen}
            onClick={theScannerIsOpen ? closeScanner : null}
          />
        </div>
        <div style={{ height: '5px' }} />
      </div>
    );
  };

  const handleScanError = data => {
    console.table(data);
    setTheScannerIsOpen(false);
    setDisplayOrderId('');
  };

  const makeReadyForNewScan = () => {
    setDisplayOrderId('');
    setTimeout(() => {
      setEditResultOrderId('');
      setScanResultOrderId('');
    }, 2500);
  };

  const makeDisplayOrderId = () => {
    setDisplayOrderId(theScannerIsOpen ? scanResultOrderId : editResultOrderId);
  };

  const theHandleClickButton = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    if (event) event.preventDefault();
    if (addScannedOrder) {
      makeDisplayOrderId();
      const existingOrderId = ordersOrderidList.filter(
        orderid => orderid === displayOrderId
      );

      if (existingOrderId.length) {
        if (addOrDelete === 'DELETE') {
          deleteScannedOrder(displayOrderId, parcelId, warehouseLocation);
        } else {
          updateScannedOrder(displayOrderId, parcelId, warehouseLocation);
        }
      } else {
        addScannedOrder(displayOrderId, parcelId, warehouseLocation);
      }
    }
    makeReadyForNewScan();
  };

  function onInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    event.persist();

    const orderId = event.target.value;
    const orderIdWithoutSpace = orderId.replace(/\s/g, '');

    if (editResultOrderId !== orderIdWithoutSpace) {
      setEditResultOrderId(orderIdWithoutSpace);
      setDisplayOrderId(orderIdWithoutSpace);
    }
  }

  function handleScan(data) {
    if (data) {
      const orderData = parseJsonData(data);
      console.log('#################', orderData);
      if (scanResultOrderId !== orderData.orderId) {
        setScanResultOrderId(orderData.orderId);
        setDisplayOrderId(orderData.orderId);

        setTheScannerIsOpen(true);
        setParcelId(orderData.parcelId);
      }
    }
  }

  const BekreftKnapp = () => {
    return (
      <>
        <div className="qr-order-scanner__confrimButtonPosition">
          <button
            className={'confirmButton'}
            onClick={theHandleClickButton}
            title={titleButton}
            disabled={disabledButton}
          >
            {titleButton}
          </button>
        </div>
      </>
    );
  };

  const ChangeLocationButton = () => (
    <>
      {warehouseLocation && (
        <div className="qr-warehouse-scanner-ChangeLocationButton">
          <div className={'editButton'} onClick={chooseWarehouseLocationModal}>
            {warehouseLocation}
            <FaCaretDown className="icon" />
          </div>
        </div>
      )}
    </>
  );

  if (!supportsWebcam) {
    return (
      <div className="qr-order-scanner">
        <div className="qr-order-scanner__scanner u-pam">
          Din nettleser støtter ikke QR-scanneren, prøv Safari på iOS eller
          Chrome på Android
        </div>
        <EditInputField isDisabled={true} />
        <BekreftKnapp />
      </div>
    );
  }
  if (theScannerIsOpen) {
    return (
      <div className={'scan'}>
        <ChangeLocationButton />
        <div className="qr-order-scanner">
          <QrReader
            delay={scanDelay}
            onError={handleScanError}
            onScan={handleScan}
            className="qr-order-scanner__scanner"
          />
        </div>
        <EditInputField isDisabled={true} />
        <BekreftKnapp />
      </div>
    );
  } else {
    return (
      <div className="qr-order-scanner">
        <button
          className="qr-order-scanner__startbutton"
          style={{ background: dataUri }}
          onClick={openScanner}
        >
          SCAN PARCEL
        </button>
        <EditInputField isDisabled={true} />
        <BekreftKnapp />
      </div>
    );
  }
}
